import { RootState } from 'editor/src/store/index';

const isImagePersonalizationPromotionBannerDismissed = (state: RootState) =>
  state.editorModules.sidebar.isImagePersonalizationPromotionBannerDismissed;

export default isImagePersonalizationPromotionBannerDismissed;
